




/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// GETCOUNTRYWITHDETAILSBYID
// GETCOUNTRYWITHDETAILSBYID
const GETCOUNTRYWITHDETAILSBYID= createAsyncThunk(
  "getCountryWithDetailsById/getCountryWithDetailsById",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getCountryWithDetailsByIdSlice = createSlice({
  name: "getCountryWithDetailsByIdSlice",
  initialState: {
    getCountryWithDetailsById: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetCountryWithDetailsById: (state) => {
        state.getCountryWithDetailsById.loading = false
        state.getCountryWithDetailsById.error = false
        state.getCountryWithDetailsById.data = []
        state.getCountryWithDetailsById.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETCOUNTRYWITHDETAILSBYID.fulfilled, (state, action) => {
      state.getCountryWithDetailsById = {
        ...state.getCountryWithDetailsById,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETCOUNTRYWITHDETAILSBYID.pending, (state, action) => {
      state.getCountryWithDetailsById = {
        ...state.getCountryWithDetailsById,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETCOUNTRYWITHDETAILSBYID.rejected, (state, action) => {
      state.getCountryWithDetailsById = {
        ...state.getCountryWithDetailsById,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getCountryWithDetailsByIdAction = {
    GETCOUNTRYWITHDETAILSBYID,
};

export { getCountryWithDetailsByIdAction };
export default getCountryWithDetailsByIdSlice.reducer;
export const {setInitialStateOfgetCountryWithDetailsById} = getCountryWithDetailsByIdSlice.actions